<script setup lang="ts">
    defineEmits<{
        apply: [];
        reset: [];
    }>();
</script>

<template>
    <div class="actions">
        <PrimaryButton
            class="apply-filters-button"
            size="small"
            native-button
            stretch
            variant="secondary"
            has-icon
            space-between
            :button-text="$t('academy.trainings.applyFilters')"
            @click="$emit('apply')"
        />

        <SharedTextIconButton
            stretch
            :label="$t('academy.listing.resetFilters')"
            @click="$emit('reset')"
        />
    </div>
</template>

<style lang="scss" scoped>
    .actions {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: var(--spacing);

        .apply-filters-button {
            display: flex;

            @media (min-width: $br-l) {
                display: none;
            }
        }
    }
</style>
